import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import CTAButton from './CTAButton';
import { BUSINESS } from '../config/business';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white overflow-hidden">
      {/* CTA Section */}
      <div className="border-b border-slate-800 min-h-[280px] sm:min-h-[320px] flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4">
              Ready to Streamline Your Business Operations?
            </h2>
            <p className="text-slate-300 text-base sm:text-lg mb-8 max-w-2xl mx-auto">
              Join hundreds of Australian businesses saving time and money with smart automation solutions.
            </p>
            <CTAButton size="lg" className="w-full sm:w-auto">
              Book a Free Consult
            </CTAButton>
            <p className="text-sm text-slate-400 mt-4">
              Get a custom roadmap for your business in 20 minutes
            </p>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 min-h-[400px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 text-left">
          {/* Company Info */}
          <div className="sm:col-span-2">
            <div className="text-xl font-bold mb-2">{BUSINESS.name}</div>
            <div className="text-xs text-slate-500 font-mono mb-6 tracking-wide">
              ABN 83 679 369 932
            </div>
            <p className="text-slate-300 mb-8 max-w-md text-sm sm:text-base leading-relaxed">
              A registered business based in Sydney, Australia. We help small businesses,
              trades, and service providers automate their operations, reduce manual work,
              and focus on what they do best.
            </p>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-blue-400 shrink-0" />
                <span className="text-slate-300 text-sm sm:text-base">{BUSINESS.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="h-5 w-5 text-blue-400 shrink-0" />
                <span className="text-slate-300 text-sm sm:text-base">{BUSINESS.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-blue-400 shrink-0" />
                <span className="text-slate-300 text-sm sm:text-base">{BUSINESS.location}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="mt-4 sm:mt-0">
            <h3 className="font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-slate-300 hover:text-white transition-colors text-sm sm:text-base">Our Services</Link></li>
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors text-sm sm:text-base">About Us</Link></li>
              <li><Link to="/products" className="text-slate-300 hover:text-white transition-colors text-sm sm:text-base">Products</Link></li>
              <li><Link to="/blog" className="text-slate-300 hover:text-white transition-colors text-sm sm:text-base">Blog</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors text-sm sm:text-base">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="mt-4 sm:mt-0">
            <h3 className="font-semibold text-lg mb-6">Services</h3>
            <ul className="space-y-3 text-sm sm:text-base">
              <li><span className="text-slate-300">CRM Automation</span></li>
              <li><span className="text-slate-300">AI Chatbots</span></li>
              <li><span className="text-slate-300">Process Automation</span></li>
              <li><span className="text-slate-300">Custom Dashboards</span></li>
              <li><span className="text-slate-300">Website Design</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-3">
          <div className="text-slate-400 text-xs sm:text-sm">
            &copy; {currentYear} {BUSINESS.name}. All rights reserved.
          </div>
          <div className="text-slate-500 text-xs font-mono">
            ABN 83 679 369 932
          </div>
          <div className="text-slate-400 text-xs sm:text-sm">
            Built with care in Sydney, Australia
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;